import React, { forwardRef } from "react";
import Popper from "@material-ui/core/Popper";
import { observer } from "mobx-react";
import StyledTooltip from "app/common/utils/StyledTooltip";
import styled, { css } from "styled-components";

function OverflowTooltip({ store }, ref) {
  const anchorEl = store.overflowTooltip.anchorEl;
  const open = Boolean(anchorEl);

  if (!store.overflowTooltip.value || !anchorEl) {
    return null;
  }

  const value = store.overflowTooltip.value;

  return (
    <Popper open={open} anchorEl={anchorEl}>
      <StyledTooltip
        open={true}
        title={value}
        arrow
        placement={(anchorEl.className === "pinnedRowText" && !store.isSubsheet) ? "top" : "bottom"}
      >
        <StyledOverflowDiv isMarginEnabled={anchorEl.className === "pinnedRowText" && !store.isSubsheet}>
        </StyledOverflowDiv>
      </StyledTooltip>
    </Popper>
  );
}

export default observer(forwardRef(OverflowTooltip));

const StyledOverflowDiv = styled.div`
  ${(props) =>
    props.isMarginEnabled
      ? css`
          margin-top: 30px;
        `
      : css`
          margin-top: 0px;
        `};
`;